import React, { Component } from "react";
import { ENocMAction, ENocMApplication } from "../../enocapi/entities";
import Strings from "@my-dld/assets/strings";
import { I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import ListDataView from "../DataView/ListDataView";
import {
	getEnocEligibility,
	getEnocOwnerAssociation,
	getEnocPropertyInfo,
	getEnocReqNo,
	getEnocReqStatus,
	getEnocSubmissionDate
} from "@my-dld/screens/MyDLD/MyRequest/EnocMollakRequests";

export interface EnocMReqProps {
	items: ENocMApplication[];
	isEligible?: boolean;
	isAction?: boolean;
	onAction: ( action: ENocMAction, request: ENocMApplication ) => void;
	selectedAction?: ENocMAction;
}

class EnocMListView extends Component<EnocMReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { items, isAction, isEligible, onAction } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader
					isAction={ isAction! }
					isEligible={ isEligible! }/>;
			} }
			renderListItem={ ( item: ENocMApplication ) => {
				return <RenderListItem
					key={ item.id }
					item={ item }
					isAction={ isAction! }
					isEligible={ isEligible! }
					onAction={ onAction }
				/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: true,
				lengthChange: false,
				order: [ [ 0, "desc" ] ]
			} );
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

export default EnocMListView;

function RenderHeader( props: { isAction: boolean, isEligible: boolean } ) {
	const { isAction, isEligible } = props;
	return <tr>
		<th className="width-auto">{ Strings.request_ref }</th>
		<th className="width-auto">{ Strings.status }</th>
		<th className="width-auto">{ Strings.submission_date }</th>
		<th className="width-auto">{ Strings.property_info }</th>
		<th className="th-title-oa">{ Strings.owners_association }</th>
		{
			isEligible &&
			<th className="width-auto">{ Strings.eligibility_status }</th>
		}
		{
			isAction && <th className="th-action-title">{ Strings.action }</th>
		}
		<th className="width-auto">{ " " }</th>
	</tr>;
}

function RenderListItem( props: {
	item: ENocMApplication, isAction: boolean, isEligible: boolean,
	onAction: ( action: ENocMAction, request: ENocMApplication ) => void
} ) {
	const { item, isAction, isEligible, onAction } = props;
	return <tr>
		<td>{ getEnocReqNo( item ) }</td>
		<td>{ getEnocReqStatus( item ) }</td>
		<td>{ getEnocSubmissionDate( item ) }</td>
		<td>{ getEnocPropertyInfo( item ) }</td>
		<td className="td-text-oa">{ getEnocOwnerAssociation( item ) }</td>
		{
			isEligible &&
			<td>{ getEnocEligibility( item ) }</td>
		}
		{
			isAction &&
			<td className="td-enoc-request-action">
				<div className="enoc-request-action">
					{
						item.actions && item.actions.length > 0 && item.actions?.map( ( action: ENocMAction, indexP: number ) => {
							//const cssClass = "btn btn-link btn-sm ";
							return <button
								key={ "#tr" + indexP }
								onClick={ () => {
									onAction( action, item );
								} }
								className={ "btn btn-link btn-sm" }>{ LocaleUtil.getLocalValue( action ) }</button>;
						} )
					}
				</div>
			</td>
		}
		<td>
			<button
				key={ "#tr-detail" + item.id } className="btn btn-sm" onClick={ () => {
				onAction( { actionId: "CanView" }, item );
			} }>
				<i className="far fa-arrow-alt-circle-right"/>
			</button>
		</td>
	</tr>;
}
